import PropTypes from 'prop-types';
import cn from 'classnames';

import { MAX_INPUT_LENGTH, sanitizeInputText } from './constants';

import styles from './styles.module.scss';

/**
 * Remaining-characters counter shown under a context field.
 *
 * Sanitizes before counting so the value it reports matches what the field
 * would actually submit, and turns red once the limit is reached.
 */
const CharCounter = ({ value, maxLength, className }) => {
  const remaining = maxLength - sanitizeInputText(value, maxLength).length;

  return (
    <div className={cn(styles['problem-meta'], className)}>
      <span
        className={cn(styles['char-counter'], {
          [styles['char-counter--limit']]: remaining === 0,
        })}
      >
        {remaining}
      </span>
    </div>
  );
};

CharCounter.propTypes = {
  value: PropTypes.string,
  maxLength: PropTypes.number,
  className: PropTypes.string,
};

CharCounter.defaultProps = {
  value: '',
  maxLength: MAX_INPUT_LENGTH,
  className: 'mb-5',
};

export default CharCounter;
